import { connect } from 'react-redux';
import Files from './Files';
import { getAuthenticationToken } from '../../../../store/actions/authentication.actions';
import { deleteLicenseFile } from '../../../../store/actions/license.actions';

const mapDispatchToProps = {
    getAuthenticationToken,
    deleteLicenseFile,
};

export default connect(null, mapDispatchToProps)(Files);
